// Models
import { createUserStoreDefaultModel } from './user/user.store'

const userModels = {
  user: createUserStoreDefaultModel(),
}

export { userModels }
